import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-18px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuAdmin = _resolveComponent("MenuAdmin")!
  const _component_MenuCategories = _resolveComponent("MenuCategories")!
  const _component_MenuSeasons = _resolveComponent("MenuSeasons")!
  const _component_MenuPartners = _resolveComponent("MenuPartners")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.shouldShowAdminMenu())
      ? (_openBlock(), _createBlock(_component_MenuAdmin, {
          key: 0,
          class: "mb-4"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_MenuCategories),
    _createVNode(_component_MenuSeasons),
    _createVNode(_component_MenuPartners)
  ]))
}